import type { ToolType } from '@/lib/types';

/** Nom court de chaque outil, tel que l'interface le montre (bas du canevas) ; le typage n'en oublie aucun (FIX-044) */
export const TOOL_LABELS: Record<ToolType, string> = {
  select: 'Sélection',
  symbol: 'Symbole',
  wire: 'Câble',
  wall: 'Mur par mur',
  rectangle: 'Rectangle de murs',
  room: 'Pièce',
  door: 'Porte',
  window: 'Fenêtre',
  pan: 'Déplacer',
  calibrate: 'Calibrer',
  measure: 'Mesurer',
  eraser: 'Effacer',
  staircase: 'Escalier',
  roof: 'Toit',
  separator: 'Séparation de pièce',
  align: 'Aligner',
  furniture: 'Mobilier',
  terrace: 'Terrasse',
  platform: 'Plateforme',
};

export const toolLabel = (tool: ToolType): string => TOOL_LABELS[tool] ?? tool;
